/**
 * Age-group settings are keyed by their own display label: a bounded band is "27-40", an
 * open-ended one "60+". Split the bounded form into its bounds so callers can render it as a
 * sentence ("27 to 40"); anything else returns null and should be shown as-is.
 *
 * splitAgeBandLabel('27-40') // { from: '27', to: '40' }
 * splitAgeBandLabel('60+')   // null
 */
export function splitAgeBandLabel(label) {
  const match = /^(\d+)\s*-\s*(\d+)$/.exec(String(label || '').trim())
  return match ? { from: match[1], to: match[2] } : null
}
